import { render, staticRenderFns } from "./Glossario.vue?vue&type=template&id=d471a802&scoped=true&"
import script from "./Glossario.vue?vue&type=script&lang=js&"
export * from "./Glossario.vue?vue&type=script&lang=js&"
import style0 from "./Glossario.vue?vue&type=style&index=0&id=d471a802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d471a802",
  null
  
)

export default component.exports